









































































































import Vue from "vue";

export default Vue.extend({
  metaInfo: {
    title: "Hakkımızda"
  },
  data() {
    return {
      features: [
        {
          title: "Turizm Kariyeri Planlayanlar",
          desc:
            "Bireysel olarak kendinizi hazırlamak ve yeterliliklerinizi zenginleştirmek için harika bir fırsat.",
          img: require("../assets/img/icon-worker-1.svg")
        },
        {
          title: "Mevcut Turizm Çalışanları",
          desc:
            "Ulusal/uluslararası geçerliliği olan eğitim sertifikalarımızla kariyerinizde daha hızlı ilerleyebileceksiniz.",
          img: require("../assets/img/icon-worker-2.svg")
        },
        {
          title: "Turizm Yöneticileri",
          desc:
            "İnsan kaynakları geliştirme konusunda hızlı, uygun ve etkin çözümler isteyen yöneticilere yönelik.",
          img: require("../assets/img/icon-worker-3.svg")
        }
      ]
    };
  }
});
